/**
 * Apollo theme: product-price-list template() indents ${M(...)} inside <span class="price">,
 * which leaves stray whitespace in the text node. Trim and remove space before € / EUR.
 */
(function () {
  'use strict';

  function tightenCurrencySpacing(t) {
    return t
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/\s+€/g, '€')
      .replace(/\s+EUR/gi, 'EUR');
  }

  function normalizePriceSpan(el) {
    if (!el) return;
    Array.from(el.childNodes).forEach(function (n) {
      if (n.nodeType === Node.TEXT_NODE) {
        var t = tightenCurrencySpacing(n.textContent);
        if (t) n.textContent = t;
        else n.parentNode.removeChild(n);
      }
    });
  }

  function trimRenderedPrices(host) {
    host.querySelectorAll('span.price--large, span.price--compare, .unit-price-measurement__price').forEach(
      normalizePriceSpan
    );
  }

  function patch() {
    var C = customElements.get('product-price-list');
    if (!C || !C.prototype || typeof C.prototype.render !== 'function') return;
    var proto = C.prototype;
    if (proto.render.__yodeymaPriceWhitespace) return;
    var prev = proto.render;
    proto.render = function yodeymaProductPriceListWhitespaceRender() {
      prev.call(this);
      trimRenderedPrices(this);
    };
    proto.render.__yodeymaPriceWhitespace = true;
  }

  function init() {
    customElements.whenDefined('product-price-list').then(patch).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
